import React from 'react';
import { LoadingSpinner, ErrorIcon } from './IconComponents';

// ===================================
// STATE COMPONENTS
// ===================================

interface ErrorStateProps {
  error: string;
  onRetry?: () => void;
  retryText?: string;
  showIcon?: boolean;
  className?: string;
}

export const ErrorState: React.FC<ErrorStateProps> = ({ 
  error, 
  onRetry, 
  retryText = 'Try Again',
  showIcon = true,
  className = ''
}) => {
  return (
    <div className={`text-center py-12 ${className}`}>
      {showIcon && (
        <div className="inline-flex items-center justify-center w-12 h-12 bg-red-100 rounded-full mb-4">
          <ErrorIcon className="h-6 w-6 text-red-600" />
        </div>
      )}
      <p className="text-red-600 mb-4">{error}</p>
      {onRetry && (
        <button
          onClick={onRetry}
          className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 transition-colors"
        >
          {retryText}
        </button>
      )}
    </div>
  );
};

interface LoadingMoreIndicatorProps {
  isVisible: boolean;
  message?: string;
  className?: string;
}

export const LoadingMoreIndicator: React.FC<LoadingMoreIndicatorProps> = ({ 
  isVisible, 
  message = 'Loading more videos',
  className = ''
}) => {
  if (!isVisible) return null;

  return (
    <div className={`flex justify-center items-center py-8 ${className}`}>
      <div className="flex items-center space-x-2 text-gray-500">
        <LoadingSpinner size="md" />
        <span>{message}</span>
      </div>
    </div>
  );
};
